import script from "./fixedBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./fixedBtn.vue?vue&type=script&setup=true&lang=js"

import "./fixedBtn.vue?vue&type=style&index=0&id=c0d8d224&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0d8d224"]])

export default __exports__